import React from 'react';
import './ProfilePopup.css'; // Crearemos este archivo a continuación

interface ProfilePopupProps {
  onClose: () => void; // Para cerrar si se hace clic fuera (manejado por el padre)
  onLogout: () => void;
  onGoToSettings: () => void; // Nueva función para ir a configuración
}

const ProfilePopup: React.FC<ProfilePopupProps> = ({ onClose, onLogout, onGoToSettings }) => {
  // Si el popup no está abierto, no renderizamos nada.

  // Usamos e.stopPropagation() para que al hacer clic dentro del popup
  // no se cierre (el evento no se propaga al overlay).
  return (
    // Ya no hay overlay, el contenedor principal posiciona el menú.
    <div className="popup-container">
      <div className="popup-content">
        <ul>
          <li onClick={onGoToSettings}>
            ⚙️ Configuración y Preferencias
          </li>
          <li className="logout-option" onClick={onLogout}>
            🚪 Cerrar Sesión
          </li>
        </ul>
      </div>
    </div>
  );
};

export default ProfilePopup;